import { each, chunk } from 'lodash'
import { app } from '../utils/store'

import { media } from '../utils/media'

import gsap from 'gsap'
import ScrollToPlugin from "gsap/ScrollToPlugin"

gsap.registerPlugin(ScrollToPlugin)

export default class Filters {
    constructor() {
        this.url = new URL(window.location.href)

        this.tease = {
            article: document.querySelectorAll('#results article.tease'),
            specials: document.querySelectorAll('.quote, section.cta-blog'),
        }

        this.result = document.querySelector('.posts')

        this.filter = {
            select: document.querySelector('[data-filters="main"] .select-main select'),
            status: document.querySelector('[data-filters="main"]'),
            main: document.querySelector('.parameters[data-filters]'),
            parameters: document.querySelectorAll('.parameters[data-filters] button[data-filter-toggler]'),
            actives: document.querySelectorAll('.parameters[data-filters] button[data-filter-toggler].active'),
            count: 0,
            counter: document.querySelector('[data-filters="main"] .counter'),
            toggler: document.querySelector('[data-filters="main"] [data-filters-toggler]')
        }

        this.disclaimer = document.getElementById('disclaimer')

        this.loadmore = {
            active: (this.tease.article.length > 60) && document.getElementById('loadmore'),
            init: false,
            iteration: 60,
            count: 0,
            chunk: 0,
            hidden: null,
            trigger: document.getElementById('loadmore'),
        }

        if (this.disclaimer) {
            this.disclaimer.classList.add('d-none')
        }

        // this.toggler() /** Mobile */

        this.filters()

        if (this.filter.select) {
            this.select()
        }

        if (this.filter.counter) {
            this.filter.counter.querySelector('.total').innerHTML = this.tease.article.length
        }

        if (this.loadmore.active) {
            each(this.tease.article, (tease) => {
                tease.classList.add('d-none')
                tease.classList.add('selected')
            })

            this.tease.hidden = document.querySelectorAll('#results article.tease.d-none.selected')

            this.loadMore()
            this.loadmore.trigger.onclick = (event) => { this.loadMore() }
        } else if (this.loadmore.trigger) {
            this.loadmore.trigger.classList.add('d-none')
        }

        if (this.url.searchParams.has('filter')) {
            if (!!document.getElementById(this.url.searchParams.get('filter'))) {
                document.getElementById(this.url.searchParams.get('filter')).click()
            }
        }

        this.updateDropdownActiveState()

        this.onResize()
        window.addEventListener('resize', this.onResize)
    }

    filters = () => {
        this.filter.count = 0

        each(this.filter.parameters, (parameter) => {
            if (!parameter.classList.contains('dropdown-toggle')) {

                parameter.addEventListener('click', (event) => {
                    let timeline = gsap.timeline()

                    var isDropdown = event.target.parentNode.parentNode.parentNode.classList.contains('dropdown'),
                        dropdownToggler = event.target.parentNode.parentNode.parentNode.querySelector('[data-bs-toggle="dropdown"]')

                    each(this.filter.main.querySelectorAll('[data-bs-toggle="dropdown"]'), (dropdown) => {
                        dropdown.classList.remove('active')
                    })

                    gsap.to(window, {
                        duration: gsap.utils.mapRange(0, document.body.scrollHeight, 0, 2.5, document.getElementById('results').offsetTop),
                        scrollTo: document.getElementById('results').offsetTop - app.header.clientHeight,
                        ease: 'Power2.easeOut',
                    })

                    if (event.target.classList.contains('active')) { // If it's already 'active'
                        event.target.classList.remove('active')
                        event.target.setAttribute('checked', false)
                        this.updateDropdownActiveState()

                        timeline.to(this.result, {
                            duration: 1,
                            autoAlpha: 0,
                            onComplete: () => { this.results(false) }
                        }).to(this.result, {
                            duration: 1,
                            autoAlpha: 1,
                        }, '>')

                        this.removeURLSearchParam('filter')
                    } else { // If is not 'active'
                        if (isDropdown) {
                            dropdownToggler.classList.add('active')

                            if (event.target.parentNode.querySelector('.counter').innerHTML > this.tease.article.length) {
                                this.filter.counter.querySelector('.current').innerHTML = this.tease.article.length
                            } else {
                                this.filter.counter.querySelector('.current').innerHTML = event.target.parentNode.querySelector('.counter').innerHTML
                            }
                        }

                        // Disable all 'active' filters
                        each(this.filter.parameters, (filter) => {
                            filter.classList.remove('active')
                            filter.setAttribute('checked', false)
                        })

                        event.target.classList.add('active')
                        event.target.setAttribute('checked', true)
                        this.updateDropdownActiveState()

                        timeline.to(this.result, {
                            duration: 1,
                            autoAlpha: 0,
                            onComplete: () => { this.results(true, isDropdown) }
                        }).to(this.result, {
                            duration: 1,
                            autoAlpha: 1,
                        }, '>')

                        this.setURLSearchParam('filter', event.target.id)
                    }
                })
            }
        })
    }

    updateDropdownActiveState = () => {
        if (!this.filter.main) { return }

        each(this.filter.main.querySelectorAll('.dropdown'), (dropdown) => {
            var dropdownToggler = dropdown.querySelector('[data-bs-toggle="dropdown"]'),
                hasActiveFilter = !!dropdown.querySelector('button[data-filter-toggler].active')

            if (!dropdownToggler) { return }

            dropdownToggler.classList.toggle('active', hasActiveFilter)
        })
    }

    select = () => {
        this.filter.select.addEventListener('change', (event) => {
            var url = event.target.value
            if (url) {
                window.location = url
            }
            return false
        })
    }

    results = (active = false, dropdown = false) => {
        if (active) {
            if (this.loadmore.active) { this.loadmore.trigger.classList.add('d-none') }
            this.filter.actives = document.querySelectorAll('.parameters[data-filters] button.active')

            var filters = new Array(),
                count = 0

            // Fill the Array of Filters
            each(this.filter.actives, (filter) => {
                filters.push(filter.id)
            })

            // Each Article do ...
            each(this.tease.article, (article) => {
                var terms = article.getAttribute('data-terms') // Get the articles terms

                article.classList.add('d-none') // Hide All Articles

                // For each article check the Filters Array and match
                each(filters, (term) => {
                    if (terms.includes(term)) { // Match here
                        article.classList.add('selected')
                        article.classList.remove('d-none')
                        count++
                    }
                })
            })

            each(this.tease.specials, (special) => {
                special.classList.add('d-none')
            })

            if (count == 0) {
                each(this.tease.article, (tease) => {
                    tease.classList.add('d-none')
                    tease.classList.add('selected')
                })

                each(this.tease.specials, (special) => {
                    special.classList.add('d-none')
                })

                this.result.classList.remove('filtered')

                if (this.loadmore.active) { this.loadmore.trigger.classList.add('d-none') }
                if (this.disclaimer) { this.disclaimer.classList.remove('d-none') }
                this.result.classList.add('d-none')

                this.filter.counter.querySelector('.current').innerHTML = 0
            } else {
                this.result.classList.remove('d-none')
                this.result.classList.add('filtered')
                if (this.disclaimer) { this.disclaimer.classList.add('d-none') }

                if (!dropdown) {
                    this.filter.counter.querySelector('.current').innerHTML = count
                } else {
                    this.filter.counter.querySelector('.current').innerHTML = this.result.querySelectorAll('.tease.selected').length
                    console.log(this.filter.counter.querySelector('.current').innerHTML, this.result.querySelectorAll('.tease.selected'))
                }
            }
        } else {
            each(this.tease.specials, (special) => {
                special.classList.remove('d-none')
            })

            this.result.classList.remove('d-none')
            this.result.classList.remove('filtered')

            if (this.loadmore.active) {
                each(this.tease.article, (tease) => {
                    tease.classList.add('d-none')
                    tease.classList.add('selected')
                })

                this.tease.hidden = document.querySelectorAll('#results article.tease.d-none.selected')

                this.loadmore.init = false
                this.loadmore.count = 0
                this.loadmore.chunk = 0

                this.loadMore()
            } else {
                each(this.tease.article, (tease) => {
                    tease.classList.remove('d-none')
                    tease.classList.remove('selected')
                })

                this.filter.counter.querySelector('.current').innerHTML = this.tease.article.length
            }
        }

        if (app.device.mobile) {
            this.filter.main.classList.remove('filters--open')
            app.body.classList.remove('overflow-hidden')

            if (this.filter.closer) {
                this.filter.closer.classList.remove('active')
            }
        }

        this.updateDropdownActiveState()
    }

    loadMore = () => {
        this.loadmore.trigger.classList.remove('d-none')

        this.loadmore.hidden = chunk(this.tease.hidden, this.loadmore.iteration)

        if (!this.loadmore.init) { // If is first load (init = false)
            each(this.loadmore.hidden[this.loadmore.chunk], (tease) => {
                gsap.set(tease, { autoAlpha: 0 })

                gsap.to(tease, {
                    duration: 1,
                    autoAlpha: 1,
                    onStart: () => { tease.classList.remove('d-none') }
                })

                this.loadmore.count++
            })

            this.tease.hidden = document.querySelectorAll('#results article.tease.d-none.selected')

            this.loadmore.chunk++
            this.loadmore.init = true

        } else { // If is already init (init = true)
            each(this.loadmore.hidden[this.loadmore.chunk], (tease) => {
                gsap.set(tease, { autoAlpha: 0 })

                gsap.to(tease, {
                    duration: 1,
                    autoAlpha: 1,
                    onStart: () => { tease.classList.remove('d-none') }
                })

                this.loadmore.count++
            })

            this.loadmore.chunk++
        }

        this.filter.counter.querySelector('.current').innerHTML = this.loadmore.count

        if (this.loadmore.count == this.tease.article.length) {
            this.loadmore.trigger.classList.add('d-none')
        }
    }

    setURLSearchParam = (key, value) => {
        this.url.searchParams.set(key, value)
        window.history.pushState({ path: this.url.href }, '', this.url.href)
    }

    removeURLSearchParam = (key) => {
        this.url.searchParams.delete(key)
        window.history.pushState({ path: this.url.href }, '', this.url.href)
    }

    toggler = () => {
        if (!this.filter.toggler || !this.filter.main) { return }

        if (!app.device.mobile) {
            this.filter.toggler.classList.remove('active')
            this.filter.main.classList.remove('filters--open')
        } else {
            if (this.filter.toggler.dataset.listener === 'true') { return }

            this.filter.toggler.addEventListener('click', (event) => {
                window.scrollTo({ top: document.getElementById('results').offsetTop, behavior: 'smooth' })
                event.target.classList.contains('active') ? event.target.classList.remove('active') : event.target.classList.add('active')

                if (this.filter.closer) {
                    this.filter.closer.classList.add('active')
                }

                this.filter.main.classList.add('filters--open')
                app.body.classList.add('overflow-hidden')
            })

            this.filter.toggler.dataset.listener = 'true'
        }
    }

    setupMobileCloser = () => {
        if (!this.filter.main) { return }

        if (!app.device.mobile) {
            if (this.filter.closer) {
                this.filter.closer.remove()
                this.filter.closer = null
            }
        } else if (!this.filter.closer) {
            this.filter.closer = document.createElement('button')

            this.filter.closer.setAttribute('data-filters-closer', '')
            this.filter.closer.classList = 'btn-closer'

            if (this.filter.main.querySelector('.parameter').classList.contains('nested')) {
                this.filter.closer.classList.add('filters--nested')
            }

            if (this.filter.closer) {
                this.filter.closer.addEventListener('click', (event) => {
                    event.target.classList.remove('active')

                    this.filter.main.classList.remove('filters--open')
                    app.body.classList.remove('overflow-hidden')
                })
            }

            this.filter.main.appendChild(this.filter.closer)
        }
    }

    onResize = () => {
        this.filter.main = document.querySelector('.parameters[data-filters]')

        // this.toggler() /** Mobile */
        // this.setupMobileCloser() /** Mobile */
        this.updateDropdownActiveState()
    }
}
